import { MoreVert, Close } from '@mui/icons-material';
import {
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Divider,
  Box,
  SvgIcon,
  Avatar,
} from '@mui/material';
import { useState } from 'react';

// Custom SVG Close Icon
// Import your SVG file
import { ReactComponent as CustomCloseIcon } from '../../assets/images/car/card-action-close-icons.svg'; // Update with your SVG path
import { useNavigate } from 'react-router-dom';
import AvatarImg from '../../assets/images/sidebar/avatar.png';
import { useSelector } from 'react-redux';
function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const auth = useSelector((s) => s.auth);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');

    // Optionally clear other app-related data
    sessionStorage.clear();
    handleClose();
    // navigate('/login');
    window.location.href = '/login';
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box className="avatar">
        <IconButton onClick={handleClick}>
          <Avatar alt="Ploni Ploni" src={AvatarImg} />
        </IconButton>
      </Box>

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: Paper,
          style: {
            width: '200px',
            borderRadius: '16px', // Adjust border radius as needed
            padding: '2px', // Optional padding for aesthetics
          },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="2px"
        >
          <Box fontWeight="bold"></Box>
          <IconButton size="small" onClick={handleClose}>
            <CustomCloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {/* <MenuItem
          key="profile_menu"
          sx={{
            fontWeight: 'bold',
            color: '#014D6C',
          }}
          // onClick={Handle show user profile modal}
        >
          {auth?.user?.name}
        </MenuItem>*/}

        <Divider sx={{ margin: 0 }} />
        <MenuItem
          key="logout_menu"
          sx={{
            fontWeight: 'bold',
            color: '#014D6C',
          }}
          onClick={handleLogout}
        >
          התנתק
        </MenuItem>
        <Divider sx={{ margin: 0 }} />
      </Menu>
    </>
  );
}

export default UserMenu;
